import React, { useState, useEffect } from 'react';
import Menu from '../../elements/Menu/menu';
import CheckAuth from '../../elements/checkAuth';
import './profitByPeriod.css';
import '../../../../styles/table.admin.css';
import config from '../../../../config/environment';
import PageMode from '../../elements/PageMode/pageMode';
import axios from 'axios';
import ModalWindow from '../../elements/ModalWindow/modal';

const MODES = ['TODAY', 'WEEK', 'MONTH', 'CUSTOM'];

export default function ProfitByPeriod() {
    const [state, setState] = useState({
        mode: 'TODAY',
        profitByPeriod: null,
        showLoader: true,

        fromDate: null,
        toDate: null,

        isShowModal: false,
        modalProviderName: null
    });

    useEffect(() => {
        const main = async () => {
            const now = new Date();
            const timeZone = now.getTimezoneOffset() * 60000;
            const currentDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const currentDayTimestamp = (+currentDay) - timeZone;

            const profitByPeriod = await getProfitByPeriod(currentDayTimestamp);

            setState(state => { return { ...state, profitByPeriod, showLoader: false }; })
        };
        main();
    }, []);

    const getProfitByPeriod = async (fromTimestamp, toTimestamp = null) => {
        try {
            const response = await axios.get(
                config.backendUrl + '/exchange-volume/profits-by-period?fromDate=' + fromTimestamp + (toTimestamp ? ('&toDate=' + toTimestamp) : ''),
                { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('jwtToken') }}
            );
            console.log(response.data); // for debug
            return response.data;

        } catch (error) {
            console.log(error.message);
            console.log(error);
            alert(error.message);
        }
    };

    // Modes
    const modeHandler = async (event) => {
        const mode = event.target.value;
        const now = new Date();
        const timeZone = now.getTimezoneOffset() * 60000;
        const currentDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        setState(state => { return({ ...state, mode, showLoader: true }); });

        let fromTimestamp;

        switch (mode) {
            case 'TODAY':
                fromTimestamp = (+currentDay) - timeZone;
                break;

            case 'WEEK':
                const firstWeekDay = currentDay.getDate() - currentDay.getDay();
                fromTimestamp = (+new Date(currentDay.setDate(firstWeekDay)) - timeZone) + 864e5;
                break;

            case 'MONTH':
                const currentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                fromTimestamp = (+currentMonth) - timeZone;
                break;
        
            default:
                return setState(state => { return({ ...state, profitByPeriod: null, showLoader: false }); });
        }

        const profitByPeriod = await getProfitByPeriod(fromTimestamp);

        setState(state => { return({ ...state, profitByPeriod, showLoader: false }); });
    };

    // Render Custom Control
    const renderCustomControl = () => {
        if (state.mode !== 'CUSTOM') { return; }

        return(
            <div className="reportByPeriod__customMode_wrapper">
                <div className="reportByPeriod__customMode_dateMainWrapper">
                    <div className="reportByPeriod__customMode_dateWrapper">
                        <span className="reportByPeriod__customMode_dateLabel">From date</span>
                        <input type="date" onChange={ dateHandler('fromDate') }/>
                    </div>

                    <div className="reportByPeriod__customMode_dateWrapper">
                        <span className="reportByPeriod__customMode_dateLabel">To date</span>
                        <input type="date" onChange={ dateHandler('toDate') } />
                    </div>
                </div>
                <button onClick={ getReportButtonHandler }>Get report</button>
            </div>
        );
    };

    const dateHandler = (dateType) => (event) => {
        const newState = { ...state };
        newState[ dateType ] = event.target.value;
        setState(() => { return(newState); });
    };

    const getReportButtonHandler = async () => {
        if (!state.fromDate) {
            alert('Invalid from date');
            return;
        }

        setState(state => { return({ ...state, showLoader: true }); });

        const fromDateArray = state.fromDate.split('-');
        const fromTimestamp = +new Date(Date.UTC(parseInt(fromDateArray[0]), (parseInt(fromDateArray[1]) - 1), parseInt(fromDateArray[2])));

        let toTimestamp = null;
        if (state.toDate) {
            const toDateArray = state.toDate.split('-');
            toTimestamp = +new Date(Date.UTC(parseInt(toDateArray[0]), (parseInt(toDateArray[1]) - 1), parseInt(toDateArray[2])));
        }

        const profitByPeriod = await getProfitByPeriod(fromTimestamp, toTimestamp);

        setState(state => { return({ ...state, profitByPeriod, showLoader: false }); });
    };

    // Data
    const renderBasicInfo = () => {
        if (state.showLoader) {
            return(
                <div className="reportByPeriod__loader">Loading...</div>
            );
        }

        if (!state.profitByPeriod) { return; }

        return(
            <div className="profitByPeriod__basicInfo_wrapper">
                <div><b>Trustee profit:</b> { state.profitByPeriod.trusteeProfitInUsd ?
                    (state.profitByPeriod.trusteeProfitInUsd + ' USD') : '[No data]' }</div>
                <div><b>Trustee profit:</b> { state.profitByPeriod.trusteeProfitInUsdActual ?
                    (state.profitByPeriod.trusteeProfitInUsdActual + ' USD (actual rate)') : '[No data]' }</div>
            </div>
        );
    };

    const renderProvidersTable = () => {
        if (state.showLoader) { return; }
        if (!state.profitByPeriod || !state.profitByPeriod.providersData || !state.profitByPeriod.providersData.length) { return; }

        const providersArray = state.profitByPeriod.providersData.filter(providerData =>
            providerData.providerProfitInUsd || providerData.providerProfitInUsdActual);

        return(
            <div className="profitByPeriod__providersTable_wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Provider</th>
                            <th>Profit</th>
                            <th>Profit (actual rate)</th>
                            <th>Volume</th>
                            <th>Volume (actual rate)</th>
                            <th>More info</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            providersArray.map((providerData, index) => {
                                return(
                                    <tr key={ index }>
                                        <td>{ providerData.providerName }</td>
                                        <td>{ providerData.providerProfitInUsd ? (providerData.providerProfitInUsd + ' USD') : '–'}</td>
                                        <td>{ providerData.providerProfitInUsdActual ? (providerData.providerProfitInUsdActual + ' USD') : '–' }</td>
                                        <td>{ providerData.providerVolumeInUsd ? (providerData.providerVolumeInUsd + ' USD') : '–'}</td>
                                        <td>{ providerData.providerVolumeInUsdActual ? (providerData.providerVolumeInUsdActual + ' USD') : '–' }</td>
                                        <td><button onClick={ () => moreInfoButtonHandler(providerData.providerName) } >More info</button></td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    };

    const moreInfoButtonHandler = (providerName) => {
        providerName ?
        setState(state => { return {
            ...state,
            isShowModal: true,
            modalProviderName: providerName
        }; })
        :
        setState(state => { return { ...state, isShowModal: false, modalProviderName: null }; });
    };

    const renderModal = () => {
        if (!state.modalProviderName) { return; }

        const providerData = state.profitByPeriod.providersData.find(data => data.providerName === state.modalProviderName);

        return(
            <>
                <ModalWindow show={ state.isShowModal } close={ moreInfoButtonHandler }
                headerText={ state.modalProviderName || '' }>
                    <div className="orderInfo__modal_header">Basic info</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Profit:</b> { providerData.providerProfitInUsd ? (providerData.providerProfitInUsd + ' USD') : '[No data]' }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Profit (actual rate):</b> { providerData.providerProfitInUsdActual ? (providerData.providerProfitInUsdActual + ' USD') : '[No data]' }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Volume:</b> { providerData.providerVolumeInUsd ? (providerData.providerVolumeInUsd + ' USD') : '[No data]' }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Volume (actual rate):</b> { providerData.providerVolumeInUsdActual ? (providerData.providerVolumeInUsdActual + ' USD') : '[No data]' }</div>
                    {
                        providerData.description ?
                        <div className="orderInfo__modal_marginBottom5"><b>Description:</b> { providerData.description }</div>
                        : null
                    }
                    <hr/>
                    {
                        !providerData.uniqueParams || !Object.keys(providerData.uniqueParams).length ?
                        null :
                        <>
                            <div className="orderInfo__modal_header">Unique params</div>
                            {
                                Object.keys(providerData.uniqueParams).map(key => {
                                    return(<div className="orderInfo__modal_marginBottom5"><b>{ key }:</b> { providerData.uniqueParams[ key ] }</div>);
                                })
                            }
                            <hr />
                        </>
                    }
                    <div className="orderInfo__modal_header">Currencies</div>
                    <div className="profitByPeriod__modalCurrenciesTable_wrapper">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Currency</th>
                                    <th>Profit</th>
                                    <th>Profit (in USD)</th>
                                    <th>Profit (in actual USD rate)</th>
                                    <th>Unique params</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    providerData.profitsByCurrency.map((currencyData, index) => {
                                        return(
                                            <tr key={ index }>
                                                <td>{ currencyData.currencyCode }</td>
                                                <td>{ currencyData.profit ? (currencyData.profit + ' ' + currencyData.currencyCode) : '–'}</td>
                                                <td>{ currencyData.profitInUsd ? (currencyData.profitInUsd + ' USD') : '–' }</td>
                                                <td>{ currencyData.profitInUsdActual ? (currencyData.profitInUsdActual + ' USD') : '–' }</td>
                                                <td>{
                                                    !currencyData.uniqueParams || !Object.keys(currencyData.uniqueParams).length ?
                                                    null :
                                                    <>
                                                        {
                                                            Object.keys(currencyData.uniqueParams).map(key => {
                                                                return(
                                                                    <>{
                                                                        currencyData.uniqueParams[ key ] ?
                                                                        <div><b>{ key }:</b> { currencyData.uniqueParams[ key ] }</div>
                                                                        : null
                                                                    }</>
                                                                );
                                                            })
                                                        }
                                                    </>
                                                }</td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </ModalWindow>
            </>
        );
    };

    return(
        <>
            <CheckAuth />
            <Menu />
            <div>
                <PageMode modesArray={ MODES } checkedMode={ state.mode } onChangeHandler={ modeHandler } />
                { renderCustomControl() }
                { renderBasicInfo() }
                { renderProvidersTable() }
                { renderModal() }
            </div>
        </>
    );
};